import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const me = payload => api.get('/platform/me', payload)
const login = payload => api.post('/platform/authenticate', payload)
const loginVerify = payload => api.post('/platform/authenticate/otp', payload)

const resetPassword = payload => api.post('/platform/reset-password', payload)
const requestResetPassword = payload => api.post('/platform/reset-password/otp', payload)
const requestResetPasswordVerify = payload => api.post('/platform/reset-password/otp/auth', payload)

export default {
  me,
  login,
  loginVerify,
  resetPassword,
  requestResetPassword,
  requestResetPasswordVerify,
}
